import { Avatar, LoadingSkeleton, Note, Text, Title } from '@ui/components/atoms';
import { EngagementScore, IEngagementScoreResponse } from '../../engagement-score';
import { usePostHogFeatureFlag } from '@ui/hooks';
import { IWhitelabelConfig } from '../../user/creator-details.typings';
import { ChatTrigger } from '@ui/components/ui';
import { IFanConversationSet } from '../../conversation';
export interface IFanProfileUser {
  avatar: string;
  name: string;
  rank: number;
  firstName?: string;
  score: IEngagementScoreResponse;
  badgesAmount: number;
  fansAmount: number;
  memberDate: string;
  creatorName: string;
  userId?: string;
  isLoading: boolean;
  hasSubPending?: boolean;
  whitelabelConfig?: IWhitelabelConfig;
  currentCommunityCreatorId: string;
  groupChats: IFanConversationSet[];
}

export function FanProfileUser({
  avatar,
  name,
  rank,
  badgesAmount,
  fansAmount,
  memberDate,
  isLoading,
  score,
  userId,
  hasSubPending,
  whitelabelConfig,
  currentCommunityCreatorId,
  groupChats,
}: IFanProfileUser) {
  const flagEnabled = usePostHogFeatureFlag('score-engagement');
  const isMemberToMemberChatEnabled = usePostHogFeatureFlag('member-to-member-chat');

  return (
    <div className="lg:border-border flex h-fit w-full flex-col  gap-4 rounded-xl border border-transparent px-8 lg:px-4 py-7 lg:max-w-xs">
      <div className={`flex w-full justify-left lg:justify-center`}>
        {isLoading ? (
          <LoadingSkeleton className="h-28 w-28 rounded-full" />
        ) : (
          <div className="flex items-start justify-between w-full space-x-2">
            <Avatar
              size="l"
              withGradient={hasSubPending ? false : true}
              src={avatar}
              displayName={name}
              isSubscribed={hasSubPending}
            />
          </div>
        )}
      </div>
      <div>
        {isLoading ? <LoadingSkeleton className="h-8 w-48" /> : <Title type="s">@{name}</Title>}
      </div>

      <div className="w-full flex justify-between">
        {score?.fan_reference_id !== userId && (
          <div>
            {flagEnabled && (
              <div className="w-fit">
                {!isLoading && (
                  <EngagementScore
                    score={score}
                    border
                    isProfile
                    isOtherProfile
                    size="sm"
                    Title="Score"
                    whitelabelConfig={whitelabelConfig as IWhitelabelConfig}
                  />
                )}
              </div>
            )}
          </div>
        )}

        {isMemberToMemberChatEnabled && score?.fan_reference_id && name && (
          <ChatTrigger
            groupChats={groupChats}
            fanName={name}
            fanId={score?.fan_reference_id}
            currentCommunityCreatorId={currentCommunityCreatorId}
            fanAvatar={avatar}
          />
        )}
      </div>
      <div>
        {isLoading ? (
          <LoadingSkeleton className="h-8 w-65 rounded-lg" />
        ) : (
          <Text type="m" className="w-full">
            LeaderBoard Position: {rank}/{fansAmount}
          </Text>
        )}
      </div>
      <div>
        {isLoading ? (
          <LoadingSkeleton className="h-8 w-40" />
        ) : (
          <Note type="m" className="w-full">
            Crew since: {memberDate}
          </Note>
        )}
      </div>
      <div>
        {isLoading ? (
          <LoadingSkeleton className="h-8 w-32" />
        ) : (
          <Note type="m" className="w-full">
            Rank: {rank}
          </Note>
        )}
      </div>
      <div>
        {isLoading ? (
          <LoadingSkeleton className="h-8 w-32" />
        ) : (
          <Note type="m" className="w-full">
            Badges: {badgesAmount}
          </Note>
        )}
      </div>
    </div>
  );
}
